import { FiShield, FiUsers, FiLock, FiMail, FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

export default function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 -mx-4 px-6 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800">
        <button
          onClick={() => navigate(-1)}
          className="text-primary hover:text-primary-dark dark:text-primary-400 dark:hover:text-primary-300 pl-2"
        >
          <FiArrowLeft className="h-6 w-6" />
        </button>
        <h1 className="text-lg font-semibold text-gray-900 dark:text-white">
          Privacy Policy
        </h1>
      </div>

      <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
        <div className="flex items-center gap-x-3 mb-6">
          <FiShield className="h-6 w-6 text-primary dark:text-primary-400" />
          <div>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
        <div className="flex items-center gap-x-3 mb-4">
          <FiUsers className="h-5 w-5 text-primary dark:text-primary-400" />
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
            Information We Collect
          </h2>
        </div>
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          We collect information you provide directly to us when you create an account,
          including your name, email address, and other contact information. We also collect
          information about your children's educational progress and attendance.
        </p>
        <ul className="list-disc list-inside text-gray-600 dark:text-gray-300 space-y-2">
          <li>Account information and credentials</li>
          <li>Contact details and preferences</li>
          <li>Educational records and progress</li>
          <li>Attendance and participation data</li>
        </ul>
      </div>

      <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
        <div className="flex items-center gap-x-3 mb-4">
          <FiLock className="h-5 w-5 text-primary dark:text-primary-400" />
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
            Data Security
          </h2>
        </div>
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          We take reasonable measures to help protect your personal information from loss,
          theft, misuse, unauthorized access, disclosure, alteration, and destruction.
        </p>
        <ul className="list-disc list-inside text-gray-600 dark:text-gray-300 space-y-2">
          <li>Encrypted data transmission</li>
          <li>Secure data storage</li>
          <li>Regular security audits</li>
          <li>Access controls and authentication</li>
        </ul>
      </div>

      <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
        <div className="flex items-center gap-x-3 mb-4">
          <FiMail className="h-5 w-5 text-primary dark:text-primary-400" />
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
            Contact Us
          </h2>
        </div>
        <p className="text-gray-600 dark:text-gray-300">
          If you have any questions about this Privacy Policy, please contact us at:{' '}
          <a 
            href="mailto:support@qudusapp.com"
            className="text-primary hover:text-primary-dark dark:text-primary-400 dark:hover:text-primary-300"
          >
            support@qudusapp.com
          </a>
        </p>
      </div>
    </div>
  );
}